import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import Profile from './Profile';
import styles from './styles';

function mapStateToProps(state) {
  const { isLoading, data } = state.dev;
  return {
    isLoading,
    data,
  };
}

const Styled = withStyles(styles)(Profile);

export default connect(
  mapStateToProps,
)(Styled);
